import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import PLATFORM from './api/global_variable'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/style/base.css?20210514'
import Calendar from 'vue-mobile-calendar'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';
import utils from './utils/utils';
import Vconsole from 'vconsole'
import 'babel-polyfill'

if(window.location.href.indexOf('.t') != -1||window.location.href.indexOf('.p') != -1||window.location.href.indexOf('192.168') != -1){
  let vConsole = new Vconsole()
  Vue.use(vConsole)
}

Vue.prototype.$layer = layer(Vue);
Vue.use(Calendar)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.GLOBAL = PLATFORM
Vue.prototype.$utils = utils
// var routeList = []
// router.beforeEach((to, from, next) => {
//   var index = -1
//   for (var i = 0; i < routeList.length; i++) {
//     if (routeList[i].name === to.name) {
//       index = i
//       break
//     }
//   }
//   if (index !== -1) {
//     routeList.splice(index + 1, routeList.length - index - 1)
//   } else if (to.name !== '登录') {
//     routeList.push({
//       'name': to.meta.title,
//       'path': to.fullPath
//     })
//   }
//   to.meta.routeList = routeList
//   next()
// })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
